export default "__VITE_ASSET__WYn_N2Jt__"